import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.85 26.99">
      <g fill-rule="evenodd">
        <g>
          <g transform="translate(0 18.77)">
            <path
              d="M21.821 1.403H3.027C-1.027-2.167.163 2.179.163 4.66c0 2.483 5.027 3.563 5.027 3.563H19.659s5.026-1.08 5.026-3.563c0-2.482 1.19-6.827-2.864-3.258"
            />
          </g>
          <path
            d="M7.875 3.023c0 .642.532 1.167 1.182 1.167h6.733c.65 0 1.182-.525 1.182-1.167l.096-.9c.028-.262.01-.528-.061-.781C16.83.716 16.405 0 15.912 0H8.936c-.49 0-.913.706-1.091 1.329a2.112 2.112 0 0 0-.064.807l.094.887ZM7.035 14.81h10.779c.389 0 .707.314.707.698a.705.705 0 0 1-.707.698H7.034a.705.705 0 0 1-.707-.698c0-.384.318-.699.708-.699m.864-3.413h9.05c.39 0 .708.314.708.698a.705.705 0 0 1-.708.698H7.9a.705.705 0 0 1-.707-.698c0-.384.318-.698.707-.698m1.136-3.414h6.778c.39 0 .708.314.708.698a.705.705 0 0 1-.708.698H9.035a.705.705 0 0 1-.708-.698c0-.384.319-.698.708-.698M3.96 19.707h16.929c.538 0 .97-.436.961-.967-.148-8.822-2.312-13.022-3.136-13.712a.952.952 0 0 0-.612-.218H6.747a.952.952 0 0 0-.613.218c-.823.69-2.988 4.89-3.136 13.712a.956.956 0 0 0 .962.967"
          />
        </g>
        <g transform="translate(32)" filter="url(#d)">
          <g transform="translate(0 18.77)">
            <path
              d="M21.821 1.403H3.027C-1.027-2.167.163 2.179.163 4.66c0 2.483 5.027 3.563 5.027 3.563H19.659s5.026-1.08 5.026-3.563c0-2.482 1.19-6.827-2.864-3.258"
            />
          </g>
          <path
            d="M7.875 3.023c0 .642.532 1.167 1.182 1.167h6.733c.65 0 1.182-.525 1.182-1.167l.096-.9c.028-.262.01-.528-.061-.781C16.83.716 16.405 0 15.912 0H8.936c-.49 0-.913.706-1.091 1.329a2.112 2.112 0 0 0-.064.807l.094.887ZM7.035 14.81h10.779c.389 0 .707.314.707.698a.705.705 0 0 1-.707.698H7.034a.705.705 0 0 1-.707-.698c0-.384.318-.699.708-.699m.864-3.413h9.05c.39 0 .708.314.708.698a.705.705 0 0 1-.708.698H7.9a.705.705 0 0 1-.707-.698c0-.384.318-.698.707-.698m1.136-3.414h6.778c.39 0 .708.314.708.698a.705.705 0 0 1-.708.698H9.035a.705.705 0 0 1-.708-.698c0-.384.319-.698.708-.698M3.96 19.707h16.929c.538 0 .97-.436.961-.967-.148-8.822-2.312-13.022-3.136-13.712a.952.952 0 0 0-.612-.218H6.747a.952.952 0 0 0-.613.218c-.823.69-2.988 4.89-3.136 13.712a.956.956 0 0 0 .962.967"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
